module.exports = __webpack_public_path__ + "mo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mo.svg
// module id = 698
// module chunks = 0